var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(!_vm.openDetailShow)?_c('templateItem'):_c('templateDetail',{attrs:{"selectedTemplate":_vm.selectedTemplate,"selectedTemplateId":_vm.selectedTemplate.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fc99a70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/systemDefine/quotationTemplateDefine.vue
// module id = null
// module chunks = 